import { render, staticRenderFns } from "./PrizeDetails.vue?vue&type=template&id=206c8fea&"
import script from "./PrizeDetails.js?vue&type=script&lang=js&"
export * from "./PrizeDetails.js?vue&type=script&lang=js&"
import style0 from "./PrizeDetails.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCol,VListItemSubtitle})
